import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { SESSION_KEYS } from "../../common/constants/sessionKeys";
import { Heading, Text } from "@radix-ui/themes";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [fromLocation, setFromLocation] = useState<string | null>();
  const [toLocation, setToLocation] = useState<string | null>();
  const [journeyDate, setJourneyDate] = useState<string | undefined | null>();
  const [confirmationId, setConfirmationId] = useState<
    string | undefined | null
  >();

  useEffect(() => {
    setFromLocation(sessionStorage.getItem(SESSION_KEYS.FROM_LOCATION));
    setToLocation(sessionStorage.getItem(SESSION_KEYS.TO_LOCATION));
    setJourneyDate(searchParams.get("journeyDate"));
    setConfirmationId(searchParams.get("confirmationId"));
  }, [searchParams]);
  return (
    <main className="container">
      <div className="my-5">
        <Link to={"/"}>Home</Link>
      </div>

      <h2 className="pb-2 text-center text-success my-5">
        Thankyou Traveller. Your booking is initiated.
      </h2>
      <Heading as="h3">Booking Details</Heading>
      <Text as="p">
        Journey Date: <strong>{journeyDate}</strong>
      </Text>
      <Text as="p">
        From: <strong>{fromLocation}</strong>
      </Text>
      <Text as="p">
        To: <strong>{toLocation}</strong>
      </Text>
      <Text as="p">
        Booking Reference Id: <strong>{confirmationId}</strong>
      </Text>
      <Text as="p">
        Please carry a valid photo ID proof along with this reference id for
        verification during your travel.
      </Text>
      <Text as="p">
        You can also check your booking details and download the ticket from{" "}
        <Link to="/my-tickets">My Tickets</Link> section.
      </Text>
      <Text as="p">Wishing you a safe and comfortable journey!</Text>
    </main>
  );
};

export default SuccessPage;
